import React, { useContext } from 'react'

import { useMediaQuery, useTheme } from '@mui/material'
import Image from 'next/image'

import Link from '../Link'

import PharmeDesktopImage from '../../../public/images/logo/logo_desktop.png'
import CosStoreLogoImg from '../../../public/images/groupement/cos/logo.png'
import OfficapLogoImg from '../../../public/images/groupement/officap/logo.png'
import GcapPharmaLogoImg from '../../../public/images/groupement/gcapPharma/logo.png'
import AeliaLogoImg from '../../../public/images/groupement/aelia/logo.png'
import CentraleMediprixLogoImg from '../../../public/images/groupement/centraleMediprix/logo.png'
import PharmacologyStoreLogoImg from '../../../public/images/groupement/pharmacologyStore/logo.png'
import CentraleDpharmaLogoImg from '../../../public/images/groupement/centraleDpharma/logo.png'
import HelloPharmacieLogoImg from '../../../public/images/groupement/helloPharmacie/logo.png'
import NormandiePharmaLogoImg from '../../../public/images/groupement/normandiePharma/logo.png'
import TrenteSeptDegresLogoImg from '../../../public/images/groupement/37degres/logo.png'

import getRoutes from '@/lib/getRoutes'
import SETTINGS from '@/src/settings'
import ProfileContext from '@/components/Context/ProfileContext'

const Logo: React.FC = () => {
  const urlHome = getRoutes({ route: 'Home' })

  const { profile } = useContext(ProfileContext)

  const theme = useTheme()
  const downSM = useMediaQuery(theme.breakpoints.down('sm'))
  return (
    <Link href={urlHome.href} as={urlHome.as} naked>
      <Image
        src={
          profile.groupAeliaStore
            ? AeliaLogoImg
            : profile.groupGcapPharma
              ? GcapPharmaLogoImg
              : profile.groupLesOfficinales
                ? OfficapLogoImg
                : profile.groupCos
                  ? CosStoreLogoImg
                  : profile.groupCentraleMediprix
                    ? CentraleMediprixLogoImg
                    : profile.groupPharmacologyStore
                      ? PharmacologyStoreLogoImg
                      : profile.groupCentraleDpharma
                        ? CentraleDpharmaLogoImg
                        : profile.groupHelloPharmacie
                          ? HelloPharmacieLogoImg
                          : profile.groupNormandiePharma
                            ? NormandiePharmaLogoImg
                            : profile.group37Degres
                              ? TrenteSeptDegresLogoImg
                              : PharmeDesktopImage
        }
        alt={SETTINGS.seo.title}
        width={downSM ? 130 : 261}
        height={downSM ? 30 : 61}
      />
    </Link>
  )
}

export default Logo
